// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.OurDifferContainer {
  background-color: #ffffff;
  padding: 70px 40px 90px;
}

.differHeading {
  color: #172639;
  font-weight: 800;
  font-size: 2.5rem;
  margin-bottom: 12px;
}

.differSubheading {
  color: #6b7280;
  font-size: 1rem;
  margin-bottom: 40px;
}

.differCarouselWrap {
  position: relative;
  max-width: 1400px;
  margin: 0 auto;
  padding: 0 80px;
}

.differCarouselWrap .carousel-control-prev,
.differCarouselWrap .carousel-control-next {
  width: 60px;
  opacity: 1;
}

.differCarouselWrap .carousel-control-prev {
  left: -20px;
}

.differCarouselWrap .carousel-control-next {
  right: -20px;
}

.differArrow {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 44px;
  height: 44px;
  border-radius: 50%;
  background-color: #172639;
  color: #ffffff;
  font-size: 16px;
}

.differCard {
  background-color: #ffffff;
  border: 1px solid #e5e5e5 !important;
  border-radius: 10px;
  height: 100%;
  cursor: pointer;
  transition: background-color 0.3s ease, border-color 0.3s ease;
}

.differCard:hover {
  background-color: #b08d3e;
  border-color: #b08d3e !important;
}

.differCard:hover .differCardTitle,
.differCard:hover .differCardText {
  color: #ffffff;
}

.differCardTitle {
  color: #172639;
  font-weight: 700;
  margin-bottom: 16px;
  transition: color 0.3s ease;
}

.differCardText {
  color: #555555;
  font-size: 0.95rem;
  line-height: 1.6;
  margin-bottom: 0;
  transition: color 0.3s ease;
}

@media (max-width: 768px) {
  .OurDifferContainer {
    padding: 50px 20px 60px;
  }

  .differHeading {
    font-size: 1.9rem;
  }

  .differSubheading {
    font-size: 0.9rem;
  }

  .differCarouselWrap {
    padding: 0 64px;
  }

  .differCarouselWrap .carousel-control-prev,
  .differCarouselWrap .carousel-control-next {
    width: 48px;
  }

  .differCarouselWrap .carousel-control-prev {
    left: -56px;
  }

  .differCarouselWrap .carousel-control-next {
    right: -56px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/OurDiffer.css"],"names":[],"mappings":"AAAA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;;EAEE,WAAW;EACX,UAAU;AACZ;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,oCAAoC;EACpC,mBAAmB;EACnB,YAAY;EACZ,eAAe;EACf,8DAA8D;AAChE;;AAEA;EACE,yBAAyB;EACzB,gCAAgC;AAClC;;AAEA;;EAEE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,uBAAuB;EACzB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;EACjB;;EAEA;;IAEE,WAAW;EACb;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,YAAY;EACd;AACF","sourcesContent":[".OurDifferContainer {\n  background-color: #ffffff;\n  padding: 70px 40px 90px;\n}\n\n.differHeading {\n  color: #172639;\n  font-weight: 800;\n  font-size: 2.5rem;\n  margin-bottom: 12px;\n}\n\n.differSubheading {\n  color: #6b7280;\n  font-size: 1rem;\n  margin-bottom: 40px;\n}\n\n.differCarouselWrap {\n  position: relative;\n  max-width: 1400px;\n  margin: 0 auto;\n  padding: 0 80px;\n}\n\n.differCarouselWrap .carousel-control-prev,\n.differCarouselWrap .carousel-control-next {\n  width: 60px;\n  opacity: 1;\n}\n\n.differCarouselWrap .carousel-control-prev {\n  left: -20px;\n}\n\n.differCarouselWrap .carousel-control-next {\n  right: -20px;\n}\n\n.differArrow {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 44px;\n  height: 44px;\n  border-radius: 50%;\n  background-color: #172639;\n  color: #ffffff;\n  font-size: 16px;\n}\n\n.differCard {\n  background-color: #ffffff;\n  border: 1px solid #e5e5e5 !important;\n  border-radius: 10px;\n  height: 100%;\n  cursor: pointer;\n  transition: background-color 0.3s ease, border-color 0.3s ease;\n}\n\n.differCard:hover {\n  background-color: #b08d3e;\n  border-color: #b08d3e !important;\n}\n\n.differCard:hover .differCardTitle,\n.differCard:hover .differCardText {\n  color: #ffffff;\n}\n\n.differCardTitle {\n  color: #172639;\n  font-weight: 700;\n  margin-bottom: 16px;\n  transition: color 0.3s ease;\n}\n\n.differCardText {\n  color: #555555;\n  font-size: 0.95rem;\n  line-height: 1.6;\n  margin-bottom: 0;\n  transition: color 0.3s ease;\n}\n\n@media (max-width: 768px) {\n  .OurDifferContainer {\n    padding: 50px 20px 60px;\n  }\n\n  .differHeading {\n    font-size: 1.9rem;\n  }\n\n  .differSubheading {\n    font-size: 0.9rem;\n  }\n\n  .differCarouselWrap {\n    padding: 0 64px;\n  }\n\n  .differCarouselWrap .carousel-control-prev,\n  .differCarouselWrap .carousel-control-next {\n    width: 48px;\n  }\n\n  .differCarouselWrap .carousel-control-prev {\n    left: -56px;\n  }\n\n  .differCarouselWrap .carousel-control-next {\n    right: -56px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
